exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Caveat:wght@400..700&display=swap);", ""]);

// module
exports.push([module.id, "h2 {\n    text-align: center;\n}\n\n.credits_signature_36KaP {\n    font-size: 1.5em;\n    font-family: \"Caveat\", cursive, sans-serif;\n}", ""]);

// exports
exports.locals = {
	"signature": "credits_signature_36KaP"
};